import { render, staticRenderFns } from "./QuotaHistory.vue?vue&type=template&id=56dae593&scoped=true"
import script from "./QuotaHistory.vue?vue&type=script&lang=js"
export * from "./QuotaHistory.vue?vue&type=script&lang=js"
import style0 from "./QuotaHistory.vue?vue&type=style&index=0&id=56dae593&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dae593",
  null
  
)

export default component.exports